import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: { type: String, default: "En cours…" } }

  connect() {
    this.boundFetch = this.onTurboFetch.bind(this)
    document.addEventListener("turbo:before-fetch-request", this.boundFetch)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.boundFetch)
  }

  disable() {
    this.element.classList.add("pointer-events-none", "opacity-60")
    this.element.value = this.textValue
    setTimeout(() => { this.element.disabled = true }, 0)
  }

  onTurboFetch(event) {
    const url = event.detail?.url?.toString()
    if (!url || !this.element.href) return
    if (!url.includes(this.element.getAttribute("href"))) return

    this.element.classList.add("pointer-events-none", "opacity-60")
    this.element.innerHTML = `
      <svg class="w-4 h-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      ${this.textValue}
    `
  }
}
